import { render } from "./SolutionDetail.vue?vue&type=template&id=a0e4f982&scoped=true"
import script from "./SolutionDetail.vue?vue&type=script&lang=js"
export * from "./SolutionDetail.vue?vue&type=script&lang=js"

import "./SolutionDetail.vue?vue&type=style&index=0&id=a0e4f982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e4f982"]])

export default __exports__